import uploadToCDNRequest from '@picsart/cloud-storage/api/uploadToCDN';
import { getContext } from '@/context';

import { ErrorMessages } from '@/consts/errors';
import { getAppStore } from '@/store';
import { ToastType } from '@/store/toast/types';
import getAccessToken from '@/utils/user/getAccessToken';
import { MINIAPP_PACKAGE_ID } from '@/consts/configs';

const uploadToCDN = async (file: File) => {
  const abortController = new AbortController();
  const accessToken = getAccessToken();

  if (!accessToken) {
    return;
  }
  const contextHeaders = getContext().utils.api.getHeaders();
  try {
    const response = await uploadToCDNRequest({
      file,
      accessToken,
      abortController,
      headers: {
        ...contextHeaders,
        'x-touchpoint': MINIAPP_PACKAGE_ID,
      },
    });

    return response.url;
  } catch {
    getAppStore().showToast(ErrorMessages.uploadToCDN, ToastType.Error);
    return null;
  }
};

export default uploadToCDN;
